module.exports = __webpack_public_path__ + "static/media/faixa-marrom-mobile.5017b456.png";